import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import { HashRouter, Route, Redirect, Switch } from 'react-router-dom'
import Startpage from './Startpage'
import LivingPlaceView from './react_components/livingplaceprocess/livingplaceview';
import LivingPlaceComparisonView from './react_components/livingplaceprocess/results/comparison_page';

class App extends Component {
  render() {
    return (
      <div className="App">
	<HashRouter className="App">
	<div className="App">
	<Redirect from="/" to="/start"/>
        <Route path="/start" component={Startpage}></Route>
	<Route path="/wohnstandorte" component={Wohnstandorte}></Route>
	</div>
	</HashRouter>
      </div>
    );
  }
}

class Wohnstandorte extends React.Component {
	render() {
		return (
	<div className="App">
	<Route path={`${this.props.match.url}`} component={LivingPlaceView}></Route>
	<Route path={`${this.props.match.url}/vergleich`} component={LivingPlaceComparisonView}></Route>
	</div>
	)
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js